import { MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Navbar({ variant = "public" }) {
  return (
    <header
      style={{
        borderBottom: "1px solid var(--border)",
        background: "#fff",
        position: "sticky",
        top: 0,
        zIndex: 20,
      }}
    >
      <div
        className="gd-page"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "14px 24px",
          gap: 12,
        }}
      >
        <Logo size="md" tagline={variant === "admin" ? "/ Operations" : undefined} />

        {variant === "public" ? (
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <Link
              to="/blog"
              className="gd-nav-link"
              data-testid="nav-blog"
            >
              Blog
            </Link>
            <span style={{ color: "#6B7280", fontSize: 13 }} className="hide-sm">
              24 × 7
            </span>
            <a
              href="https://wa.me/919036705707"
              target="_blank"
              rel="noreferrer"
              className="gd-pill"
              style={{ textDecoration: "none" }}
              data-testid="nav-whatsapp"
            >
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: 99,
                  background: "var(--success)",
                  display: "inline-block",
                }}
              />
              <MessageCircle size={14} color="#111827" />
              WhatsApp
            </a>
          </div>
        ) : (
          <span
            className="gd-badge-blue"
            style={{ background: "#111827", color: "#fff" }}
            data-testid="admin-badge"
          >
            Admin
          </span>
        )}
      </div>
    </header>
  );
}
